// extracted by mini-css-extract-plugin
export default {"-large":"JxxYN580XDcHIhEPy1m4","pill":"EcJCKi99bcUul8JFmLWz","pillHoverPremium":"ggiRvI_PzXZxDB6wpPp8","pillHoverSecondary":"g2hkCP1j1TlRs3a_n3vQ","hidden":"xcGRQwOgx_V2P2MU8dZR"};